import get from 'lodash/get';
import { eventActions, navigationActions } from '../actions';

const { max, min } = Math;

const handlePiggybankEvent = (state, { currentPageIndex, type }) => {
  switch (type) {
    case 'onNavigate':
      return {
        ...state,
        page: currentPageIndex,
      };

    default:
      return state;
  }
};

export default (
    segmentsConfig,
    segmentNames,
    initialState = { segment: 0, page: 0 }
  ) =>
  (state = initialState, action) => {
    switch (action.type) {
      case navigationActions.NEXT_SEGMENT:
        return {
          ...state,
          page: 0,
          segment: min(segmentNames.length - 1, state.segment + 1),
        };

      case navigationActions.PREV_SEGMENT: {
        const segment = max(0, state.segment - 1);
        const pages = get(segmentsConfig[segmentNames[segment]], 'pages', []);

        return {
          ...state,
          page: pages.length,
          segment,
        };
      }

      case navigationActions.NEXT_PAGE: {
        const { pages } = segmentsConfig[segmentNames[state.segment]];

        return {
          ...state,
          page: min(pages.length - 1, state.page + 1),
        };
      }

      case navigationActions.PREV_PAGE:
        return {
          ...state,
          page: max(0, state.page - 1),
        };

      case eventActions.PIGGYBANK_EVENT:
        return handlePiggybankEvent(state, action.event);

      default: {
        const { segmentName, ...newState } = state;

        return {
          ...newState,
          segment: segmentName
            ? segmentNames.indexOf(segmentName)
            : newState.segment,
        };
      }
    }
  };
